import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const urgents = [
  { key: 'urgent_1' },
  { key: 'urgent_2' },
  { key: 'urgent_3' },
  { key: 'urgent_4' },
];

const planifiables = [
  { key: 'planifiable_1' },
  { key: 'planifiable_2' },
  { key: 'planifiable_3' },
  { key: 'planifiable_4' },
];

export default function UrgentVsPlanifiable() {
  const { t } = useTranslation('blogsignes');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="urgent" className="scroll-mt-28">
      <h2
        className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-6 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        {t('urgent_h2')}
      </h2>

      <p className={`text-slate-primary/70 text-base md:text-lg leading-relaxed mb-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('urgent_intro')}
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Urgent */}
        <div className={`bg-red-50 border border-red-100 rounded-xl p-6 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`} style={{ transitionDelay: '150ms' }}>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-100 shrink-0">
              <i className="ri-alarm-warning-line text-red-600 text-lg" />
            </div>
            <h3 className="font-manrope font-bold text-red-700 text-lg">{t('urgent_title')}</h3>
          </div>
          <ul className="space-y-3">
            {urgents.map((item, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-red-200 shrink-0 mt-0.5">
                  <i className="ri-close-line text-red-700 text-xs" />
                </div>
                <span className="text-red-800 text-sm md:text-base">{t(item.key)}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Planifiable */}
        <div className={`bg-emerald-50 border border-emerald-100 rounded-xl p-6 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`} style={{ transitionDelay: '250ms' }}>
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-emerald-100 shrink-0">
              <i className="ri-calendar-check-line text-emerald-600 text-lg" />
            </div>
            <h3 className="font-manrope font-bold text-emerald-700 text-lg">{t('planifiable_title')}</h3>
          </div>
          <ul className="space-y-3">
            {planifiables.map((item, idx) => (
              <li key={idx} className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full bg-emerald-200 shrink-0 mt-0.5">
                  <i className="ri-check-line text-emerald-700 text-xs" />
                </div>
                <span className="text-emerald-800 text-sm md:text-base">{t(item.key)}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}